import React, { useState, useEffect } from 'react';
import { Modal, Button, Table } from 'react-bootstrap';
import axios from 'axios';
import './ItemsDefault.css'

const ScanModal = ({
  showModal,
  closeModal,
  showMoreMissing,
  setShowMoreMissing,
  showMoreExtra,
  setShowMoreExtra,
}) => {
  const [discrepancies, setDiscrepancies] = useState({ missing: [], extra: [] });
  const [loading, setLoading] = useState(true);

  const apiUrl = 'https://jwapi.infosware-test.in/api/compare';

  // Fetch discrepancies data when the modal is opened
  useEffect(() => {
    const fetchDiscrepancies = async () => {
      try {
        const response = await axios.get(apiUrl);
        setDiscrepancies(response.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching discrepancies data:', error);
        setLoading(false);
      }
    };

    if (showModal) {
      fetchDiscrepancies();
    }
  }, [showModal]);

  return (
    <Modal show={showModal} onHide={closeModal} size="lg" centered>
      <Modal.Header id='modalheader' closeButton>
        <Modal.Title>Discrepancies Found</Modal.Title>
      </Modal.Header>
      <Modal.Body id="modalbody">
        {loading ? (
          <p>Loading...</p>
        ) : (
          <>
            {/* Table for Missing IDs */}
            {discrepancies.missing.length > 0 && (
              <div>
                <h5>Missing IDs:</h5>
                <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th>RFID</th>
                        <th>Item Type</th>
                      </tr>
                    </thead>
                    <tbody>
                      {discrepancies.missing.slice(0, showMoreMissing ? discrepancies.missing.length : 7).map((item, index) => (
                        <tr key={index}>
                          <td>{item.rfid}</td>
                          <td>{item.itemType}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>

              </div>
            )}

            {/* Table for Extra IDs */}
            {discrepancies.extra.length > 0 && (
              <div>
                <h5>Extra IDs:</h5>
                <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th>RFID</th>
                        <th>Item Type</th>
                      </tr>
                    </thead>
                    <tbody>
                      {discrepancies.extra.slice(0, showMoreExtra ? discrepancies.extra.length : 7).map((item, index) => (
                        <tr key={index}>
                          <td>{item.rfid}</td>
                          <td>{item.itemType || 'Not Available'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </div>
            )}
          </>
        )}
      </Modal.Body>
      <Modal.Footer id="modalheader">
        {/* <Button variant="secondary" onClick={closeModal}>
          Close
        </Button> */}
      </Modal.Footer>
    </Modal>
  );
};

export default ScanModal;
